import React from "react";
export const ListboxWrapper = ({children}) => (
  <div className="w-full px-1 py-2 rounded-xl border-default-200 dark:border-default-100">
    {children}
  </div>
);
